// extracted by mini-css-extract-plugin
export default {"container":"BillingCard_container__kdMdW","title":"BillingCard_title__ru10a","value":"BillingCard_value__AuemR","icon":"BillingCard_icon__r-fmY"};